import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "signature-form-data signature-form-comments" }

import FormField from "@/components/common/FormField.vue3.vue"
import { SignatureDocumentFieldType } from '@/store/enums';
import {computed, onMounted, Ref, ref} from 'vue';
import {usePortalIntakeStore} from "@/store/PortalIntakeModule";


export default /*@__PURE__*/_defineComponent({
  __name: 'PatientComments.vue3',
  props: {
    documentIndex: {},
    fieldIndex: {}
  },
  emits: ["update"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;
const value = ref('');

const intakeStore = usePortalIntakeStore();
const validationState = computed(() => intakeStore.getters.getSignatureFieldValidationState({ docIndex: props.documentIndex, fieldIndex: props.fieldIndex }));
const setDocumentField = (docIndex: number, fieldIndex: number, field: {type: SignatureDocumentFieldType, value: Ref<string|undefined>}) => 
    intakeStore.dispatch('setDocumentField', {docIndex, fieldIndex, field});

onMounted(() =>
    setDocumentField(props.documentIndex, props.fieldIndex, {type: SignatureDocumentFieldType.Comments, value})
);

return (_ctx: any,_cache: any) => {
  const _component_p_text_area = _resolveComponent("p-text-area")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(FormField, { "validation-state": validationState.value }, {
      default: _withCtx(() => [
        _createVNode(_component_p_text_area, {
          modelValue: value.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
          class: _normalizeClass([validationState.value?.invalid && 'field-validation-error', 'w-full']),
          "auto-resize": "",
          rows: "3",
          maxlength: "1000",
          placeholder: "Enter comments here...",
          onInput: _cache[1] || (_cache[1] = ($event: any) => (emit('update')))
        }, null, 8, ["modelValue", "class"])
      ]),
      _: 1
    }, 8, ["validation-state"]),
    _createElementVNode("span", _hoisted_1, _toDisplayString(value.value), 1)
  ]))
}
}

})